export default [
  {
    path: '/management',
    name: 'management',
    meta: {
      index: 5,
      type: 'login'
    },
    component: () =>
      import(/* webpackChunkName: "management" */ '@/pages/manage-center/management/index.vue')
  },
  {
    path: '/purchase/history',
    name: 'purchase-history',
    meta: {
      index: 1
    },
    component: () =>
      import(/* webpackChunkName: "purchase-history" */ '@/pages/manage-center/purchase/history/index.vue')
  },
  {
    path: '/purchase/history/detail/:id',
    name: 'purchase-history-detail',
    meta: {
      index: 2
    },
    component: () =>
      import(/* webpackChunkName: "purchase-history-detail" */ '@/pages/manage-center/purchase/history/detail.vue')
  },
  {
    path: '/purchase/product-stocks',
    name: 'purchase-product-stocks',
    props: true,
    meta: {
      index: 2
    },
    component: () =>
      import(/* webpackChunkName: "purchase-product-stocks" */ '@/pages/manage-center/purchase/product-stocks/index.vue')
  },
  {
    path: '/myorder',
    name: 'myorder',
    props: true,
    meta: {
      index: 1
    },
    component: () =>
      import(/* webpackChunkName: "myorder" */ '@/pages/manage-center/myorder/index.vue')
  },
  {
    path: '/myorder-details',
    name: 'myorder-details',
    props: true,
    meta: {
      index: 2
    },
    component: () =>
      import(/* webpackChunkName: "myorder" */ '@/pages/manage-center/myorder/details.vue')
  },
  {
    path: '/receiver-address',
    name: 'receiver-address',
    props: true,
    meta: {
      index: 4
    },
    component: () =>
      import(/* webpackChunkName: "address" */ '@/pages/manage-center/receiver-address/index.vue')
  },
  {
    path: '/receiver-address/add',
    name: 'receiver-address-add',
    props: true,
    meta: {
      index: 5
    },
    component: () =>
      import(/* webpackChunkName: "address" */ '@/pages/manage-center/receiver-address/add.vue')
  },
  {
    path: '/orderer',
    name: 'orderer',
    props: true,
    meta: {
      index: 6
    },
    component: () =>
      import(/* webpackChunkName: "myorder" */ '@/pages/manage-center/order-management/index.vue')
  },
  {
    path: '/my-credit',
    name: 'my-credit',
    props: true,
    meta: {
      index: 5
    },
    component: () =>
      import(/* webpackChunkName: "my-credit" */ '@/pages/manage-center/my-credit/index.vue')
  },
  {
    path: '/orderer/details',
    name: 'orderer-details',
    props: true,
    meta: {
      index: 7
    },
    component: () =>
      import(/* webpackChunkName: "myorder" */ '@/pages/manage-center/order-management/order-details/order-details.vue')
  },
  {
    path: '/apply/refund',
    name: 'apply-refund',
    props: true,
    meta: {
      index: 7
    },
    component: () =>
      import(/* webpackChunkName: "myorder" */ '@/pages/manage-center/order-management/apply-refund/apply-refund.vue')
  }
]
